var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappyRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 124,
    viewBox: "0 0 82 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.7256 22.7347L18.1682 30.8982C16.3602 31.245 15.1757 32.9918 15.5225 34.7998L21.8021 67.5363C22.1489 69.3443 23.8958 70.5288 25.7037 70.182L68.2611 62.0185C70.0691 61.6717 71.2536 59.9248 70.9068 58.1169L64.6272 25.3804C64.2804 23.5724 62.5336 22.3879 60.7256 22.7347Z",
    fill: "#4D8DF4",
    stroke: "#606060",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6269 42.7638C32.4349 42.4169 34.3102 44.271 33.9633 42.463C33.6165 40.655 31.8697 39.4705 30.0617 39.8173C28.2537 40.1642 27.0692 41.911 27.416 43.719C27.7629 45.5269 28.8189 43.1106 30.6269 42.7638Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5426 38.3679C55.3506 38.0211 57.2262 39.8751 56.8794 38.0672C56.5325 36.2592 54.7857 35.0747 52.9777 35.4215C51.1698 35.7683 49.9853 37.5151 50.3321 39.3231C50.6789 41.1311 51.7346 38.7148 53.5426 38.3679Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2961 50.9879C35.4881 51.3347 34.3036 53.0815 34.6504 54.8895C34.9972 56.6975 36.744 57.882 38.552 57.5352L37.2961 50.9879ZM51.6466 55.0233C53.4547 54.6765 54.6391 52.9297 54.2923 51.1217C53.9455 49.3137 52.1987 48.1292 50.3907 48.476L51.6466 55.0233ZM38.552 57.5352L51.6466 55.0233L50.3907 48.476L37.2961 50.9879L38.552 57.5352Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1582 14.1149L40.4032 26.3733",
    stroke: "#606060",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6035 46.1669L9.35365 59.309",
    stroke: "#606060",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6855 34.3666L79.217 45.9906",
    stroke: "#606060",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1578 14.115C36.8503 13.3908 37.6353 11.4317 36.9111 9.73917C36.187 8.04664 34.2278 7.26164 32.5353 7.98582C30.8428 8.71 30.0578 10.6691 30.7819 12.3617C31.5061 14.0542 33.4652 14.8392 35.1578 14.115Z",
    stroke: "#606060",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.686 39.875C46.2284 39.771 46.5838 39.247 46.4797 38.7046C46.3757 38.1622 45.8516 37.8068 45.3092 37.9109C44.7668 38.0149 44.4115 38.5389 44.5155 39.0813C44.6196 39.6237 45.1436 39.9791 45.686 39.875Z",
    fill: "#4D8DF4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3956_129237)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.5,
    cy: 106,
    rx: 23.5,
    ry: 4,
    fill: "#A6C6F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3956_129237",
    x: 8,
    y: 96,
    width: 67,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.827451 0 0 0 0 0.886275 0 0 0 0 0.980392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3956_129237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3956_129237",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyRobot);
export default __webpack_public_path__ + "static/media/happy_robot.aa0276acf2b3a87dd4b0d086c52b1cf6.svg";
export { ForwardRef as ReactComponent };